// src/components/pages/Movimento/edit/form/tabs/itensTabPanel.js

import React, { useMemo, useState } from 'react';
import { ThemeProvider, Button, Box, Tooltip, IconButton, useMediaQuery } from '@mui/material';
import { AddShoppingCart, RemoveShoppingCart, ShoppingCart, Print, Inventory2 } from '@mui/icons-material';
import { MaterialReactTable } from 'material-react-table';

import Checkbox from '../../../../../form/Checkbox';
import DataList from '../../../../../form/DataList';
import Input from '../../../../../form/Input';
import InputNumber from '../../../../../form/InputNumber';
import Select from '../../../../../form/Select';
import SelectEmpresa from '../../../../../form/SelectEmpresa';

import { formatarNumero, formatarNumero3Digitos, maskDecimal, maskConferenciaCodigo } from '../../../../../../utils/masks';
import { getMRTDefaultProps } from '../../../../../../helpers/mrt/getMRTDefaultProps';
import { retornaDataHora } from '../../../../../../utils/retornaDataFormatada';
import { relatorios } from '../../../../../../api/relatorios';
import { printPdf } from '../../../../../../utils/funcoes';

import HistoricoCustosProduto from '../../modules/itens/HistoricoCustosProduto';
import CadastroRapidoProdutoXml from '../../modules/itens/CadastroRapidoProdutoXml';
import CustomDialog from '../../../../../layout/CustomDialog';

export default function ItensTabPanel({
    // UI/Tema
    theme,

    // môdulo headless
    module,
    limites,
    // contexto
    operacao,
    parametro,
    operacaoParametros,
    profile,
    casaDecimal,
    utiliza3digitos,

    // options
    OptionsTabelaPreco,
    OptionsEmpresa,
    OptionsAlmoxarifados,
    OptionsSituacaoItem,

    // flags
    divLimite,
    disabledBtnItem,

    // permissões
    podeEditar,
    podeIncluir,
    podeCancelar,
    podeImprimir,
    podeEditarItem,
    podeCancelarItem,
    podeImprimirItem,
    //message
    setFlashMessage,
}) {
    const { main, draft, list, flags: moduleFlags, state, actions, mrt, display } = module;
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [openRecalcularCustos, setOpenRecalcularCustos] = useState(false);
    // =========================
    // contrato novo
    // =========================
    const dados = main.state;
    const novoProduto = draft.value;

    const modoTabelaPreco = operacaoParametros?.formTabelaOrProduto === true && !!novoProduto?.tabelaPrecoId;

    const manual = !!dados?.id && !modoTabelaPreco;

    const data = modoTabelaPreco ? (list.items ?? []) : (list.view ?? list.items ?? []);

    const rowCount = modoTabelaPreco ? data.length : (list.rowCount ?? data.length);

    const { isSaving = false, isRecalculatingCosts = false } = moduleFlags || {};

    // estados do modal de produtos no modo cadastro rápido (modo XML)
    const [openCadastroRapidoXml, setOpenCadastroRapidoXml] = useState(false);
    const [itemXmlCadastroRapido, setItemXmlCadastroRapido] = useState(null);

    // =========================
    // compat temporária
    // =========================
    const {
        Produto,
        Embalagem,
        OptionsProdutos,
        OptionsEmbalagem,
        parceiroItem,
        optionsParceiroItem,
        colaboradorItem,
        optionsColaboradorItem,
    } = state;

    // =========================
    // actions do módulo
    // =========================
    const {
        change: onChange,
        focus: onFocus,
        blur: onBlur,
        clear: onLimpar,
        submitDraft: onSalvarItem,
        selectRow: onItemAction,
        recalculateCosts: onRecalculateCosts,
    } = actions;

    // =========================
    // mrt do módulo
    // =========================
    const {
        state: {
            columnFilterFns = {},
            columnFilters = [],
            globalFilter = '',
            pagination = { pageIndex: 0, pageSize: 5 },
            sorting = [],
        } = {},
        setters: {
            setColumnFilterFnsMode = () => {},
            setColumnFilters = () => {},
            setGlobalFilter = () => {},
            setPagination = () => {},
            setSorting = () => {},
        } = {},
        flags: { isLoading: isMrtLoading = false, isRefetching: isMrtRefetching = false, isError: isMrtError = false } = {},
    } = mrt || {};

    const mrtDefaultProps = getMRTDefaultProps({
        mrt: {
            columnFilterFns,
            columnFilters,
            globalFilter,
            pagination,
            sorting,

            rowCount,

            isLoading: isMrtLoading,
            isRefetching: isMrtRefetching,
            isError: isMrtError,

            setColumnFilters,
            setColumnFiltersMode: setColumnFilterFnsMode,
            setGlobalFilter,
            setPagination,
            setSorting,
        },

        parametro: profile?.parametros,

        isMobile,

        rowSelectSize: 50,
    });
    /* regras para bloquear o botão de salvar */
    const usaTabelaPreco = !!profile?.parametros?.itens?.usaTabelaPreco;
    const uiShow = profile.uiTabs.itens.show;
    const digitaDatalistProduto = profile.uiTabs.itens.digitaDatalistProduto;

    const getColumnsByOperacao = (profile, operacao, casaDecimal, OptionsSituacaoItem) => {
        const sigla = operacao.sigla;
        const descricao = operacao.descricao;
        if (profile.layout === 'conferencia') {
            return [
                {
                    id: 'produto',
                    header: `Itens da conferência ${descricao} - ${sigla}`,
                    columns: [
                        {
                            accessorKey: 'Situacao.descricao',
                            header: 'Situação',
                            filterFn: 'equals',
                            filterVariant: 'select',
                            filterSelectOptions: OptionsSituacaoItem,
                        },
                        {
                            accessorKey: 'Produto.descricao',
                            id: 'Produto.descricao',
                            header: 'Descrição',
                            //you can access a cell in many callback column definition options like this
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                onClick: () => {
                                    console.info(row.original);
                                },
                            }),
                        },
                        {
                            accessorKey: 'Embalagem.descricao',
                            id: 'Embalagem.descricao',
                            header: 'Embalagem',
                        },
                        {
                            accessorKey: 'quantidadeOriginal',
                            header: 'Qtd Original',
                            muiTableBodyCellProps: {
                                align: 'right',
                            },
                            accessorFn: (row) =>
                                !row.quantidade
                                    ? ''
                                    : parseFloat(row.quantidadeOriginal / row.fator)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: casaDecimal,
                                          maximumFractionDigits: casaDecimal,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'quantidade',
                            header: 'Conferido',
                            muiTableBodyCellProps: {
                                align: 'right',
                            },
                            accessorFn: (row) =>
                                !row.quantidade
                                    ? ''
                                    : parseFloat(row.quantidade)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: casaDecimal,
                                          maximumFractionDigits: casaDecimal,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'quantidadeFalta',
                            header: 'Falta',
                            muiTableBodyCellProps: {
                                align: 'right',
                            },
                            accessorFn: (row) =>
                                !row.quantidadeFalta
                                    ? ''
                                    : parseFloat(row.quantidadeFalta)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: casaDecimal,
                                          maximumFractionDigits: casaDecimal,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'valorUnitario',
                            header: 'Valor Unitário',
                            muiTableBodyCellProps: {
                                align: 'right',
                            },
                            accessorFn: (row) =>
                                !row.valorUnitario
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.valorUnitario)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'descontoValor',
                            header: 'Desconto',
                            muiTableBodyCellProps: {
                                align: 'right',
                            },
                            accessorFn: (row) =>
                                !row.descontoValor
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.descontoValor)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'valorTotal',
                            header: 'Valor Total',
                            muiTableBodyCellProps: {
                                align: 'right',
                            },
                            accessorFn: (row) =>
                                !row.valorTotal
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.valorTotal)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'pesoBruto',
                            header: 'Peso Bruto',
                            muiTableBodyCellProps: {
                                align: 'right',
                            },
                            accessorFn: (row) =>
                                !row.pesoBruto
                                    ? ''
                                    : parseFloat(row.pesoBruto)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'volumes',
                            header: 'Volumes',
                            muiTableBodyCellProps: {
                                align: 'center',
                            },
                            accessorFn: (row) => `${row.volumes || 0} / ${dados.volumes || 0}`,
                        },
                        {
                            accessorKey: 'Almoxarifado.descricao',
                            id: 'Almoxarifado.descricao',
                            header: 'Almoxarifado',
                        },
                    ],
                },
            ];
        }
        if (profile.layout === 'industria') {
            return [
                {
                    id: 'produto',
                    header: 'Itens do Movimento',
                    columns: [
                        {
                            accessorKey: 'Produto.descricao',
                            id: 'Produto.descricao',
                            header: 'Descrição',
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                onClick: () => {
                                    console.info(row.original);
                                },
                            }),
                        },
                        {
                            accessorKey: 'Pessoa.descricao',
                            id: 'Pessoa.descricao',
                            header: profile.uiTabs.itens.labels.labParceiro,
                        },
                        {
                            accessorKey: 'Colaborador.descricao',
                            id: 'Colaborador.descricao',
                            header: profile.uiTabs.itens.labels.labColaborador,
                        },
                        {
                            accessorKey: 'quantidade',
                            header: 'Quantidade',
                            muiTableBodyCellProps: { align: 'right' },

                            accessorFn: (row) =>
                                !row.quantidade
                                    ? ''
                                    : parseFloat(row.quantidade)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: casaDecimal,
                                          maximumFractionDigits: casaDecimal,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'Embalagem.descricao',
                            id: 'Embalagem.descricao',
                            header: 'Embalagem',
                        },
                        {
                            accessorKey: 'refugo',
                            header: 'Refugo',
                            type: 'boolean',
                            columnFilterModeOptions: ['equals'],
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            filterVariant: 'select',
                            Cell: ({ row }) => {
                                const value = row.original.refugo;
                                return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                        {
                            accessorKey: 'pesoBruto',
                            header: 'Peso Bruto',
                            muiTableBodyCellProps: { align: 'right' },
                            accessorFn: (row) =>
                                !row.pesoBruto
                                    ? ''
                                    : parseFloat(row.pesoBruto)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'pesoLiquido',
                            header: 'Peso Líquido',
                            muiTableBodyCellProps: { align: 'right' },
                            accessorFn: (row) =>
                                !row.pesoLiquido
                                    ? ''
                                    : parseFloat(row.pesoLiquido)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'Almoxarifado.descricao',
                            id: 'Almoxarifado.descricao',
                            header: 'Almoxarifado',
                        },
                    ],
                },
            ];
        }
        if (profile.layout === 'requisicao') {
            return [
                {
                    id: 'produto',
                    header: 'Itens do Movimento',
                    columns: [
                        {
                            accessorKey: 'Produto.descricao',
                            id: 'Produto.descricao',
                            header: 'Descrição',
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                onClick: () => {
                                    console.info(row.original);
                                },
                            }),
                        },
                        {
                            accessorKey: 'Embalagem.descricao',
                            id: 'Embalagem.descricao',
                            header: 'Embalagem',
                        },
                        {
                            accessorKey: 'quantidade',
                            header: 'Quantidade',
                            muiTableBodyCellProps: { align: 'right' },

                            accessorFn: (row) =>
                                !row.quantidade
                                    ? ''
                                    : parseFloat(row.quantidade)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: casaDecimal,
                                          maximumFractionDigits: casaDecimal,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'pesoLiquido',
                            header: 'Peso Líquido',
                            muiTableBodyCellProps: { align: 'right' },
                            accessorFn: (row) =>
                                !row.pesoLiquido
                                    ? ''
                                    : parseFloat(row.pesoLiquido)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'Almoxarifado.descricao',
                            id: 'Almoxarifado.descricao',
                            header: 'Almoxarifado',
                        },
                    ],
                },
            ];
        }
        if (profile.layout === 'vendas') {
            return [
                {
                    id: 'produto',
                    header: 'Itens do Movimento',
                    columns: [
                        {
                            accessorKey: 'pedido',
                            header: 'Itens',
                            type: 'boolean',
                            columnFilterModeOptions: ['equals'],
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: true },
                                { label: 'Não', value: false },
                            ],
                            filterVariant: 'select',
                            Cell: ({ row }) => {
                                const value = row.original.pedido;
                                return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                        {
                            accessorKey: 'Produto.descricao',
                            id: 'Produto.descricao',
                            header: 'Descrição',
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                onClick: () => {
                                    console.info(row.original);
                                },
                            }),
                        },
                        {
                            accessorKey: 'quantidade',
                            header: 'Quantidade',
                            muiTableBodyCellProps: { align: 'right' },

                            accessorFn: (row) =>
                                !row.quantidade
                                    ? ''
                                    : parseFloat(row.quantidade)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: casaDecimal,
                                          maximumFractionDigits: casaDecimal,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'Embalagem.descricao',
                            id: 'Embalagem.descricao',
                            header: 'Embalagem',
                        },
                        {
                            accessorKey: 'precoBase',
                            header: 'Preço Tabela',
                            muiTableBodyCellProps: { align: 'right' },
                            accessorFn: (row) =>
                                !row.precoBase
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.precoBase)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'valorUnitario',
                            header: 'Valor Unitário',
                            muiTableBodyCellProps: { align: 'right' },
                            accessorFn: (row) =>
                                !row.valorUnitario
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.valorUnitario)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'descontoValor',
                            header: 'Desconto',
                            muiTableBodyCellProps: { align: 'right' },
                            accessorFn: (row) =>
                                !row.descontoValor
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.descontoValor)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'descontoFinanceiro',
                            header: 'Desconto Financeiro',
                            muiTableBodyCellProps: { align: 'right' },
                            accessorFn: (row) =>
                                !row.descontoFinanceiro
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.descontoFinanceiro)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'valorTotal',
                            header: 'Valor Total',
                            muiTableBodyCellProps: { align: 'right' },
                            accessorFn: (row) =>
                                isNaN(row.valorTotal)
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.valorTotal)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'pesoBruto',
                            header: 'Peso Bruto',
                            muiTableBodyCellProps: { align: 'right' },
                            accessorFn: (row) =>
                                !row.pesoBruto
                                    ? ''
                                    : parseFloat(row.pesoBruto)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'pesoLiquido',
                            header: 'Peso Líquido',
                            muiTableBodyCellProps: { align: 'right' },
                            accessorFn: (row) =>
                                !row.pesoLiquido
                                    ? ''
                                    : parseFloat(row.pesoLiquido)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'tabelaPreco.descricao',
                            header: 'Tabela Preço',
                            accessorFn: (row) => row?.tabelaPreco?.descricao || '',
                        },
                        {
                            accessorKey: 'Almoxarifado.descricao',
                            id: 'Almoxarifado.descricao',
                            header: 'Almoxarifado',
                        },
                    ],
                },
            ];
        }
        //para operações contábeis
        if (profile.contabil) {
            return [
                {
                    id: 'produto',
                    header: 'Itens do Movimento',
                    columns: [
                        ...(profile?.id === 'XML'
                            ? [
                                  {
                                      accessorKey: 'statusXml',
                                      header: 'XML',
                                      size: 120,
                                      Cell: ({ row }) => {
                                          const item = row.original;

                                          if (item.pendenteXml || item.pendente) {
                                              return <span style={{ color: 'red', fontWeight: 'bold' }}>Pendente</span>;
                                          }

                                          return <span style={{ color: 'green', fontWeight: 'bold' }}>Localizado</span>;
                                      },
                                  },
                                  {
                                      accessorKey: 'alertasXml',
                                      header: 'Alerta XML',
                                      size: 200,
                                      Cell: ({ row }) => {
                                          const alertas = row.original.alertasXml || row.original.alertas || [];

                                          const corMensagem = row.original.tipoMensagemXml === 'success' ? 'green' : 'red';

                                          return alertas?.length ? (
                                              <span style={{ color: corMensagem }}>{alertas.join(' | ')}</span>
                                          ) : null;
                                      },
                                  },
                              ]
                            : []),
                        ...(profile?.layout === 'entrada'
                            ? [
                                  {
                                      accessorKey: 'Produto.codigoFabricante',
                                      id: 'Produto.codigoFabricante',
                                      header: 'Cód Fabricante',
                                  },
                              ]
                            : [
                                  {
                                      accessorKey: 'Produto.codigo',
                                      id: 'Produto.codigo',
                                      header: 'Cód Produto',
                                  },
                              ]),
                        {
                            accessorKey: 'Produto.descricao',
                            id: 'Produto.descricao',
                            header: 'Descrição',
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                onClick: () => {
                                    console.info(row.original);
                                },
                            }),
                        },
                        {
                            accessorKey: 'quantidade',
                            header: 'Quantidade',
                            muiTableBodyCellProps: { align: 'right' },

                            accessorFn: (row) =>
                                !row.quantidade
                                    ? ''
                                    : parseFloat(row.quantidade)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: casaDecimal,
                                          maximumFractionDigits: casaDecimal,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'Embalagem.descricao',
                            id: 'Embalagem.descricao',
                            header: 'Embalagem',
                        },
                        {
                            accessorKey: 'valorUnitario',
                            header: 'Valor Unitário',
                            muiTableBodyCellProps: { align: 'right' },
                            accessorFn: (row) =>
                                !row.valorUnitario
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.valorUnitario)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'descontoValor',
                            header: 'Desconto',
                            muiTableBodyCellProps: { align: 'right' },
                            accessorFn: (row) =>
                                !row.descontoValor
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.descontoValor)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'descontoFinanceiro',
                            header: 'Desconto Financeiro',
                            muiTableBodyCellProps: { align: 'right' },
                            accessorFn: (row) =>
                                !row.descontoFinanceiro
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.descontoFinanceiro)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'valorTotal',
                            header: 'Valor Total',
                            muiTableBodyCellProps: { align: 'right' },
                            accessorFn: (row) =>
                                isNaN(row.valorTotal)
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.valorTotal)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'icms',
                            header: 'ICMS',
                            muiTableBodyCellProps: { align: 'right' },
                            accessorFn: (row) =>
                                isNaN(row.icms)
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.icms)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'fecoep',
                            header: 'FECOEP',
                            muiTableBodyCellProps: { align: 'right' },
                            accessorFn: (row) =>
                                isNaN(row.fecoep)
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.fecoep)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'ipi',
                            header: 'IPI',
                            muiTableBodyCellProps: { align: 'right' },
                            accessorFn: (row) =>
                                isNaN(row.ipi)
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.ipi)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'icmsST',
                            header: 'ICMS ST',
                            muiTableBodyCellProps: { align: 'right' },
                            accessorFn: (row) =>
                                !row.icmsST
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.icmsST)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'fecoepST',
                            header: 'Fecoep ST',
                            muiTableBodyCellProps: { align: 'right' },
                            accessorFn: (row) =>
                                !row.fecoepST
                                    ? ''
                                    : parseFloat(row.fecoepST)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'custoCalculado',
                            header: 'Custo',
                            muiTableBodyCellProps: { align: 'right' },
                            accessorFn: (row) =>
                                !row.custoCalculado
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.custoCalculado)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'Almoxarifado.descricao',
                            id: 'Almoxarifado.descricao',
                            header: 'Almoxarifado',
                        },
                    ],
                },
            ];
        }
        // Operações comuns
        return [
            {
                id: 'produto',
                header: 'Itens do Movimento',
                columns: [
                    {
                        accessorKey: 'Produto.descricao',
                        id: 'Produto.descricao',
                        header: 'Descrição',
                        muiTableBodyCellProps: ({ row, cell }) => ({
                            onClick: () => {
                                console.info(row.original);
                            },
                        }),
                    },
                    {
                        accessorKey: 'quantidade',
                        header: 'Quantidade',
                        muiTableBodyCellProps: { align: 'right' },

                        accessorFn: (row) =>
                            !row.quantidade
                                ? ''
                                : parseFloat(row.quantidade)?.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: casaDecimal,
                                      maximumFractionDigits: casaDecimal,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }),
                    },
                    {
                        accessorKey: 'Embalagem.descricao',
                        id: 'Embalagem.descricao',
                        header: 'Embalagem',
                    },
                    {
                        accessorKey: 'precoBase',
                        header: 'Preço Tabela',
                        muiTableBodyCellProps: { align: 'right' },
                        accessorFn: (row) =>
                            !row.precoBase
                                ? ''
                                : 'R$ ' +
                                  parseFloat(row.precoBase)?.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }),
                    },
                    {
                        accessorKey: 'valorUnitario',
                        header: 'Valor Unitário',
                        muiTableBodyCellProps: { align: 'right' },
                        accessorFn: (row) =>
                            !row.valorUnitario
                                ? ''
                                : 'R$ ' +
                                  parseFloat(row.valorUnitario)?.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }),
                    },
                    {
                        accessorKey: 'descontoValor',
                        header: 'Desconto',
                        muiTableBodyCellProps: { align: 'right' },
                        accessorFn: (row) =>
                            !row.descontoValor
                                ? ''
                                : 'R$ ' +
                                  parseFloat(row.descontoValor)?.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }),
                    },
                    {
                        accessorKey: 'descontoFinanceiro',
                        header: 'Desconto Financeiro',
                        muiTableBodyCellProps: { align: 'right' },
                        accessorFn: (row) =>
                            !row.descontoFinanceiro
                                ? ''
                                : 'R$ ' +
                                  parseFloat(row.descontoFinanceiro)?.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }),
                    },
                    {
                        accessorKey: 'valorTotal',
                        header: 'Valor Total',
                        muiTableBodyCellProps: { align: 'right' },
                        accessorFn: (row) =>
                            isNaN(row.valorTotal)
                                ? ''
                                : 'R$ ' +
                                  parseFloat(row.valorTotal)?.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }),
                    },
                    {
                        accessorKey: 'pesoBruto',
                        header: 'Peso Bruto',
                        muiTableBodyCellProps: { align: 'right' },
                        accessorFn: (row) =>
                            !row.pesoBruto
                                ? ''
                                : parseFloat(row.pesoBruto)?.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }),
                    },
                    {
                        accessorKey: 'pesoLiquido',
                        header: 'Peso Líquido',
                        muiTableBodyCellProps: { align: 'right' },
                        accessorFn: (row) =>
                            !row.pesoLiquido
                                ? ''
                                : parseFloat(row.pesoLiquido)?.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }),
                    },
                    {
                        accessorKey: 'Almoxarifado.descricao',
                        id: 'Almoxarifado.descricao',
                        header: 'Almoxarifado',
                    },
                ],
            },
        ];
    };

    const columns = useMemo(() => {
        if (!operacao || !operacao.sigla) return [];
        return getColumnsByOperacao(profile, operacao, casaDecimal, OptionsSituacaoItem);
    }, [profile, operacao, casaDecimal, OptionsSituacaoItem]);

    const exibeHistoricoCustos = Boolean(operacao?.entrada) && Boolean(operacaoParametros?.compoeCustoProduto);

    const handleOpenCadastroRapidoXml = (item) => {
        setItemXmlCadastroRapido(item);
        setOpenCadastroRapidoXml(true);
    };

    const handleCloseCadastroRapidoXml = () => {
        setOpenCadastroRapidoXml(false);
        setItemXmlCadastroRapido(null);
    };

    const normalizarCodigoBarrasXml = (valor) => {
        const codigo = String(valor || '')
            .trim()
            .toUpperCase();

        if (!codigo || codigo === 'SEM GTIN' || codigo === 'SEM GTIN TRIB' || /^0+$/.test(codigo)) {
            return '';
        }

        return codigo;
    };

    // helper para normalizar a embalagem do produto
    const localizarProdutoEmbalagemXml = ({ produto, itemXml, usarGtinTributavel, produtoEmbalagemIdEscolhida }) => {
        const embalagens = Array.isArray(produto?.produtoEmbalagens) ? produto.produtoEmbalagens : [];

        const gtinComercial = normalizarCodigoBarrasXml(
            itemXml?.gtinComercial ?? itemXml?.codigoBarrasComercial ?? itemXml?.cEAN
        );

        const gtinTributavel = normalizarCodigoBarrasXml(
            itemXml?.gtinTributavel ?? itemXml?.codigoBarrasTributavel ?? itemXml?.cEANTrib
        );

        const codigosOrdenados = usarGtinTributavel ? [gtinTributavel, gtinComercial] : [gtinComercial, gtinTributavel];

        /*
         * Havendo código, respeita is_cEANTrib e utiliza
         * o outro código somente como alternativa.
         */
        for (const codigo of codigosOrdenados.filter(Boolean)) {
            const embalagemEncontrada = embalagens.find(
                (produtoEmbalagem) => normalizarCodigoBarrasXml(produtoEmbalagem?.codigoBarras) === codigo
            );

            if (embalagemEncontrada) {
                return embalagemEncontrada;
            }
        }

        /*
         * Sem GTIN, respeita uma embalagem explicitamente escolhida para o item.
         * Sem escolha explícita, mantém o comportamento anterior de usar a principal.
         */
        if (!gtinComercial && !gtinTributavel) {
            if (produtoEmbalagemIdEscolhida != null) {
                return embalagens.find((v) => Number(v.id) === Number(produtoEmbalagemIdEscolhida)) || null;
            }
            return embalagens.find((produtoEmbalagem) => produtoEmbalagem?.principal === true) || null;
        }

        return null;
    };

    const atualizarItemXmlResolvido = (produto, mensagem, contextoVinculo = {}) => {
        if (!produto?.id || !itemXmlCadastroRapido) {
            return false;
        }
        // A seleção explícita sem GTIN não pode encobrir um código original do XML.
        if (contextoVinculo.somenteVinculoItem && (
            normalizarCodigoBarrasXml(itemXmlCadastroRapido.gtinComercial ?? itemXmlCadastroRapido.codigoBarrasComercial ?? itemXmlCadastroRapido.cEAN) ||
            normalizarCodigoBarrasXml(itemXmlCadastroRapido.gtinTributavel ?? itemXmlCadastroRapido.codigoBarrasTributavel ?? itemXmlCadastroRapido.cEANTrib)
        )) {
            setFlashMessage?.('O item original possui GTIN. Utilize a vinculação de códigos.', 'warning');
            return false;
        }

        const produtoEmbalagem = localizarProdutoEmbalagemXml({
            produto,
            itemXml: itemXmlCadastroRapido,
            usarGtinTributavel: Boolean(dados?.is_cEANTrib),
            produtoEmbalagemIdEscolhida: contextoVinculo.somenteVinculoItem
                ? contextoVinculo.produtoEmbalagemId : undefined,
        });

        if (!produtoEmbalagem?.id) {
            setFlashMessage?.(
                'Não foi possível determinar a embalagem do item. Revise os códigos de barras e a embalagem principal do produto.',
                'warning'
            );

            return false;
        }

        const embalagem = produtoEmbalagem?.Embalagem ?? produtoEmbalagem?.embalagem ?? null;

        const embalagemId = Number(produtoEmbalagem?.embalagemId ?? embalagem?.id) || null;

        if (!embalagemId || !embalagem) {
            setFlashMessage?.('A embalagem vinculada ao produto não foi retornada completamente.', 'warning');

            return false;
        }

        const fator = Number(embalagem?.fator ?? produtoEmbalagem?.fator ?? itemXmlCadastroRapido?.fator ?? 1) || 1;

        const precoXml = Number(
            itemXmlCadastroRapido.precoNegociado ?? itemXmlCadastroRapido.valorUnitario ?? itemXmlCadastroRapido.vUnCom ?? 0
        );

        const custoAtual = Number(itemXmlCadastroRapido.custo || 0);

        const custoCalculadoAtual = Number(itemXmlCadastroRapido.custoCalculado || 0);

        const custo = custoAtual > 0 ? custoAtual : precoXml;

        const custoCalculado = custoCalculadoAtual > 0 ? custoCalculadoAtual : custo;

        const itemAtualizado = {
            ...itemXmlCadastroRapido,

            produtoId: produto.id,
            Produto: produto,

            // custo provisório exibido no frontend
            custo: Number(custo).toFixed(2),
            custoCalculado: Number(custoCalculado).toFixed(2),

            produtoEmbalagem,
            produtoEmbalagemId: produtoEmbalagem.id,

            embalagemId,
            embalagemIdTabela: embalagemId,

            Embalagem: embalagem,
            embalagemDescricao: embalagem?.descricao ?? null,

            fator,

            pedido: true,
            localizado: true,

            pendenteXml: false,
            pendente: false,

            alertasXml: mensagem ? [mensagem] : [],
            alertas: mensagem ? [mensagem] : [],

            tipoMensagemXml: mensagem ? 'success' : null,
        };

        const listaAtualizada = (list.items || []).map((item) => {
            const mesmoItem =
                item === itemXmlCadastroRapido ||
                (itemXmlCadastroRapido?.uuid && item.uuid === itemXmlCadastroRapido.uuid) ||
                (itemXmlCadastroRapido?.id != null && item.id === itemXmlCadastroRapido.id);

            return mesmoItem ? itemAtualizado : item;
        });

        list.setItems(listaAtualizada);

        handleCloseCadastroRapidoXml();
        return true;
    };

    return (
        <div style={{ margin: '1em' }}>
            {/* Linha 1 */}
            <div>
                {usaTabelaPreco && (
                    <>
                        <Select
                            name="novoProduto.tabelaPrecoId"
                            text="Tabela de Preço"
                            options={OptionsTabelaPreco}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={novoProduto.tabelaPrecoId}
                            notOptNull={false}
                        />
                        {/* outros campos específicos da tabela */}
                    </>
                )}
                {uiShow.conferenciaCodigo && (
                    <>
                        <Input
                            text="Código identificador"
                            type="text"
                            name="novoProduto.conferenciaCodigo"
                            placeholder=""
                            inputWidth="150px"
                            title={`Digite o código identificador da etiqueta da matéria-prima`}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={maskConferenciaCodigo(novoProduto.conferenciaCodigo) || ''}
                        />
                    </>
                )}
                <DataList
                    text="Produto"
                    name="Produto.descricao"
                    placeholder="Pesquise o Produto"
                    inputWidth="500px"
                    filteredOptions={OptionsProdutos}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={Produto?.descricao || ''}
                    required={false}
                    readonly={!digitaDatalistProduto}
                />

                <Select
                    name="novoProduto.embalagemId"
                    title="Escolha a embalagem do produto"
                    text="Embalagem"
                    options={OptionsEmbalagem}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={novoProduto?.embalagemId ?? ''}
                    isEnum={false}
                    notOptNull={true}
                />
                {usaTabelaPreco && (
                    <>
                        <InputNumber
                            text="Preço Tabela"
                            type="text"
                            name="preco"
                            placeholder="Valor R$"
                            inputWidth="100px"
                            title="digite o valor da venda"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={display.preco}
                        />
                        <InputNumber
                            text="Preço Unitário"
                            type="text"
                            name="precoUnitario"
                            placeholder="Valor R$"
                            inputWidth="100px"
                            title="preço unitário do produto"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={display.precoUnitario}
                            readonly={true}
                        />
                    </>
                )}
                <SelectEmpresa
                    text="Empresa"
                    name="empresaId"
                    options={OptionsEmpresa}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={novoProduto?.empresaId || dados?.empresaId}
                    required
                    notOptNull={true}
                />
                {uiShow.almoxarifado && (
                    <>
                        <Select
                            name="novoProduto.almoxarifadoId"
                            title="Almoxarifado de destino do item"
                            text="Almoxarifado"
                            inputWidth="180"
                            options={OptionsAlmoxarifados}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={novoProduto?.almoxarifadoId ?? ''}
                            isEnum={false}
                            notOptNull={false}
                        />
                    </>
                )}
                {uiShow.disponivel && (
                    <>
                        <InputNumber
                            text="Disponível"
                            type="text"
                            name="novoProduto.disponivel"
                            placeholder="Estoque"
                            inputWidth="100px"
                            title="estoque disponível"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={novoProduto?.disponivel ? formatarNumero(novoProduto.disponivel) : ''}
                            readonly={true}
                        />
                    </>
                )}
            </div>
            {/* Linha 2 */}
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                {uiShow?.producaoMinima && (
                    <>
                        <InputNumber
                            text={'Produção Mínima'}
                            type="text"
                            name="novoProduto.producaoMinima"
                            placeholder=""
                            inputWidth="100px"
                            title={`Produção mínima conforme instrução no cadastro do produto`}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={
                                novoProduto.producaoMinima
                                    ? utiliza3digitos
                                        ? formatarNumero3Digitos(novoProduto.producaoMinima)
                                        : formatarNumero(novoProduto.producaoMinima)
                                    : ''
                            }
                            readonly={true}
                        />
                    </>
                )}
                {uiShow?.sugestao && (
                    <>
                        <InputNumber
                            text={'Sugestão'}
                            type="text"
                            name="novoProduto.sugestao"
                            placeholder=""
                            inputWidth="100px"
                            title={`Produção sugerida conforme pedidos no sistema`}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={
                                novoProduto.sugestao
                                    ? utiliza3digitos
                                        ? formatarNumero3Digitos(novoProduto.sugestao)
                                        : formatarNumero(novoProduto.sugestao)
                                    : ''
                            }
                            readonly={true}
                        />
                    </>
                )}

                <InputNumber
                    text="Quantidade"
                    type="text"
                    name="novoProduto.quantidade"
                    placeholder="Quantidade"
                    inputWidth="100px"
                    title={`digite a quantidade `}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={
                        novoProduto?.quantidade
                            ? Number(novoProduto.quantidade) === 0
                                ? utiliza3digitos
                                    ? '0,000'
                                    : '0,00'
                                : utiliza3digitos
                                  ? formatarNumero3Digitos(novoProduto.quantidade)
                                  : formatarNumero(novoProduto.quantidade)
                            : ''
                    }
                    readonly={false}
                />

                {uiShow.permiteItemDuplicado && (
                    <>
                        <Checkbox
                            title="Permite itens duplicados na conferência, para isso é necessário conferir, pesar e marcar o volume, exemplo vol 1/6, sendo necessário apenas colocar o numero do volume o número total de volumes fica na aba de cabeçalho"
                            text="Item Dup"
                            name="permiteItemDuplicado"
                            handleOnChange={onChange}
                            value={dados.permiteItemDuplicado}
                            checked={!!dados.permiteItemDuplicado}
                        />
                    </>
                )}
                {uiShow.refugo && (
                    <>
                        <Checkbox
                            title="Informa um registro de refugo, são impurezas coletadas durante a separação do material"
                            text="Refugo"
                            name="novoProduto.refugo"
                            handleOnChange={onChange}
                            value={novoProduto.refugo}
                            checked={!!novoProduto.refugo}
                        />
                    </>
                )}
                {uiShow.parceiroItem && (
                    <>
                        <DataList
                            text="Parceiro"
                            title="Parceiro de origem do material, o refugo será debitado da conta do parceiro"
                            name="parceiroItem.descricao"
                            placeholder={'Pesquise o parceiro'}
                            inputWidth="300px"
                            filteredOptions={optionsParceiroItem}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={parceiroItem?.descricao || ''}
                        />
                    </>
                )}
                {uiShow.colaboradorItem && (
                    <>
                        <DataList
                            text={profile?.uiTabs?.itens?.labels?.labColaborador}
                            title={`Colaborador responsável pelo trabalho`}
                            name="colaboradorItem.descricao"
                            placeholder={'Pesquise o colaborador'}
                            inputWidth="300px"
                            filteredOptions={optionsColaboradorItem}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={colaboradorItem?.descricao || ''}
                        />
                    </>
                )}

                {uiShow.volumes && (
                    <>
                        <Input
                            text="Volume"
                            type="text"
                            name="novoProduto.volumes"
                            inputWidth="100px"
                            placeholder=""
                            title="Volume refere-se a quantidade de caixas, pacotes, fardos contidos no movimento, facilita para localizar o objeto"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={novoProduto.volumes}
                            disabled={!novoProduto.produtoId}
                            textAlign="center"
                        />
                    </>
                )}
                {uiShow.volumesTotal && (
                    <>
                        <Input
                            text="Total de Volumes"
                            type="text"
                            name="novoProduto.volumesTotal"
                            inputWidth="100px"
                            placeholder=""
                            title="Total de volumes refere-se a quantidade de caixas, pacotes, fardos contidos no movimento  deste item específico, o valor será utilizado em processo de geração de etiqueta sem pesagem, aguardando a pesagem dos volumes futuramente no processo de separação"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={novoProduto.volumesTotal}
                            disabled={!novoProduto.produtoId}
                            textAlign="center"
                        />
                    </>
                )}
                {uiShow.dataConferencia && (
                    <>
                        <Input
                            text="Data Conferência"
                            type="datetime-local"
                            name="novoProduto.dataConferencia"
                            placeholder="Data de conferência"
                            title="Data de conferência do item"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={novoProduto.dataConferencia ? retornaDataHora(novoProduto.dataConferencia) : ''}
                            readonly={false}
                            inputWidth={'150px'}
                        />
                    </>
                )}
                {uiShow.situacaoId && (
                    <>
                        <Select
                            name="novoProduto.situacaoId"
                            title="Define a situação do movimento"
                            text="Situação"
                            inputWidth="170px"
                            options={OptionsSituacaoItem}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={novoProduto.situacaoId}
                            isEnum={false}
                            notOptNull={false}
                        />
                    </>
                )}
                {uiShow.precoNegociado && (
                    <>
                        <InputNumber
                            text="Preço"
                            type="text"
                            name="novoProduto.precoNegociado"
                            placeholder="Valor R$"
                            inputWidth="100px"
                            title="preço negociado, esse valor será validado pelas regras disponíveis no sistema"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={novoProduto?.precoNegociado ? formatarNumero(novoProduto.precoNegociado) : ''}
                            readonly={false}
                        />
                    </>
                )}

                {uiShow.descontoPercentual && (
                    <>
                        <InputNumber
                            text="Desc %"
                            type="text"
                            name="novoProduto.descontoPercentual"
                            placeholder="desconto %"
                            inputWidth="100px"
                            title="digite o percentual de desconto"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={novoProduto?.descontoPercentual ? formatarNumero(novoProduto.descontoPercentual) : ''}
                            readonly={false}
                        />
                    </>
                )}
                {uiShow.descontoValor && (
                    <>
                        <InputNumber
                            text="Desc R$"
                            type="text"
                            name="novoProduto.descontoValor"
                            placeholder="desconto em R$"
                            inputWidth="100px"
                            title="digite o valor do desconto em R$"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={novoProduto?.descontoValor ? formatarNumero(novoProduto.descontoValor) : ''}
                            readonly={false}
                        />
                    </>
                )}
                {uiShow.valorUnitario && (
                    <>
                        <InputNumber
                            text="Valor"
                            title="Valor do produto com os descontos aplicados"
                            type="text"
                            name="novoProduto.valorUnitario"
                            placeholder="Valor R$"
                            inputWidth="100px"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={novoProduto?.valorUnitario ? formatarNumero(novoProduto.valorUnitario) : ''}
                            readonly={true}
                        />
                    </>
                )}
                {uiShow.precoPorUnidade && (
                    <>
                        <InputNumber
                            text="Unitário"
                            type="text"
                            name="novoProduto.precoPorUnidade"
                            placeholder="Valor R$"
                            inputWidth="100px"
                            title="Preço da unidade do parceiro"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={novoProduto?.precoPorUnidade ? formatarNumero(novoProduto.precoPorUnidade) : ''}
                            readonly={true}
                        />
                    </>
                )}
                {uiShow.valorTotal && (
                    <>
                        <InputNumber
                            text="Total"
                            type="text"
                            name="novoProduto.valorTotal"
                            placeholder="Valor R$"
                            inputWidth="100px"
                            title="Valor total do produto na compra"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={novoProduto?.valorTotal ? formatarNumero(novoProduto.valorTotal) : ''}
                            readonly={true}
                        />
                    </>
                )}
                {divLimite && (
                    <>
                        {' '}
                        <InputNumber
                            text="Limite"
                            type="text"
                            name="limiteDisponivel"
                            placeholder="Valor R$"
                            inputWidth="100px"
                            title={`Limite do centro de custo ${dados?.centroCustoDescricao ?? ''}`}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={formatarNumero(Number(limites.limiteDisponivel).toFixed(2))}
                            readonly={true}
                        />
                    </>
                )}
                {uiShow.totalValor && (
                    <>
                        <InputNumber
                            text="Total do Pedido"
                            type="text"
                            name="totalValor"
                            placeholder="Valor R$"
                            inputWidth="100px"
                            title={`Valor total do ${operacao?.descricao}`}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados?.totalValor ? maskDecimal(dados.totalValor) : ''}
                            readonly={true}
                        />
                    </>
                )}

                <Button
                    variant="contained"
                    color="inherit"
                    onClick={onLimpar}
                    style={{ marginLeft: '10px', minWidth: '80px', fontSize: '14px' }}
                >
                    Limpar
                </Button>
                <Button
                    variant="contained"
                    color={novoProduto?.funcao?.toLowerCase() === 'cancelar' ? 'error' : 'info'}
                    onClick={onSalvarItem}
                    disabled={disabledBtnItem || isSaving}
                    style={{ marginLeft: '10px', minWidth: '80px', fontSize: '14px' }}
                >
                    {isSaving ? 'Processando...' : novoProduto?.funcao}
                </Button>
            </div>
            {/* Linha 3 TRIBUTAÇÃO / IMPOSTOS */}
            {uiShow.cfop && (
                <div>
                    <InputNumber
                        text="Disponível"
                        type="text"
                        name="novoProduto.disponivel"
                        placeholder="Estoque"
                        inputWidth="100px"
                        title="estoque disponível"
                        handleOnChange={onChange}
                        handleOnFocus={onFocus}
                        handleOnBlur={onBlur}
                        value={novoProduto?.disponivel ? formatarNumero(novoProduto.disponivel) : ''}
                        readonly={true}
                    />
                </div>
            )}

            {/* GRID */}
            <ThemeProvider theme={theme}>
                <MaterialReactTable
                    {...mrtDefaultProps}
                    columns={columns}
                    data={data || []}
                    rowCount={rowCount || 0}
                    getRowId={(row) => row.uuid ?? row.id}
                    manualPagination={manual}
                    manualSorting={manual}
                    manualFiltering={manual}
                    renderDetailPanel={({ row }) => (
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                gap: '10px',
                                padding: '10px',
                            }}
                        >
                            {exibeHistoricoCustos && (
                                <HistoricoCustosProduto
                                    empresaId={row.original?.empresaId ?? dados?.empresaId}
                                    produtoId={row.original?.produtoId ?? row.original?.Produto?.id}
                                    movimentoIdIgnorar={row.original?.movimentoId}
                                    movimentoItemIdIgnorar={row.original?.id}
                                    limite={10}
                                />
                            )}
                            {row.original.saldoEstoque?.map((empresa, indexEmpresa) => (
                                <Box
                                    key={indexEmpresa}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        width: '100%',
                                        gap: '10px',
                                        backgroundColor: '#353535',
                                        padding: '10px 20px',
                                        borderRadius: '5px',
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                        color: '#fff',
                                    }}
                                >
                                    <Box sx={{ fontWeight: 'bold', fontSize: '16px' }}>
                                        {empresa.nomeFantasia ?? `Empresa ID: ${empresa.empresaId}`}
                                    </Box>

                                    {empresa.almoxarifados?.map((almox, indexAlmox) => (
                                        <Box
                                            key={indexAlmox}
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '8px',
                                                backgroundColor: '#505050',
                                                padding: '10px',
                                                borderRadius: '4px',
                                            }}
                                        >
                                            <Box sx={{ fontWeight: 'bold' }}>
                                                Almoxarifado: {almox.descricao ?? `ID ${almox.almoxarifadoId}`}
                                            </Box>

                                            {almox.saldos?.map((saldo, indexSaldo) => (
                                                <Box
                                                    key={indexSaldo}
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        backgroundColor: '#606060',
                                                        padding: '6px 12px',
                                                        borderRadius: '4px',
                                                        fontSize: '14px',
                                                    }}
                                                >
                                                    <span>Situação: {saldo.descricaoSituacao ?? `ID ${saldo.situacaoId}`}</span>
                                                    <span>
                                                        Entradas: {saldo.entradas} | Saídas: {saldo.saidas} |{' '}
                                                        <strong>Saldo: {saldo.disponivel}</strong>
                                                    </span>
                                                </Box>
                                            ))}

                                            <Box
                                                sx={{
                                                    marginTop: '8px',
                                                    padding: '6px 12px',
                                                    borderTop: '1px solid #888',
                                                    fontWeight: 'bold',
                                                    display: 'flex',
                                                    justifyContent: 'flex-end',
                                                    color: '#fff',
                                                }}
                                            >
                                                Total disponível no almoxarifado:{' '}
                                                <strong style={{ marginLeft: '6px' }}>
                                                    {almox.saldos?.reduce((acc, s) => acc + (s.disponivel ?? 0), 0)}
                                                </strong>
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            ))}
                        </Box>
                    )}
                    renderRowActions={({ row, table }) => {
                        const printEtiquetaGrande = async (obj) => {
                            // se obj for nulo, undefined, ou um objeto vazio, sai da função
                            if (!obj || Object.keys(obj).length === 0) {
                                console.warn('Nenhum dado para gerar etiqueta.');
                                setFlashMessage('Não é possível imprimir a etiqueta!', 'warning');
                                return;
                            }

                            const response = await relatorios('etiquetaGrande', 'etiquetaGrande', obj);

                            //gera o pdf
                            printPdf(response.data);
                        };

                        const printItemXml = async (obj) => {
                            // se obj for nulo, undefined, ou um objeto vazio, sai da função
                            if (!obj || Object.keys(obj).length === 0) {
                                console.warn('Nenhuma informação do XML para gerar impressão');
                                setFlashMessage('Não é possível imprimir informações do arquivo XML!', 'warning');
                                return;
                            }

                            const response = await relatorios('etiquetaItemXML', 'etiquetaItemXML', obj);

                            //gera o pdf
                            printPdf(response.data);
                        };
                        return (
                            <>
                                <Box sx={{ display: 'flex', gap: '1rem' }}>
                                    <Tooltip arrow placement="top" title={`${row.original.pedido ? 'Editar' : 'Adicionar'}`}>
                                        <span>
                                            <IconButton
                                                onClick={() =>
                                                    onItemAction?.(
                                                        row.original,
                                                        row.index,
                                                        row.original.pedido ? 'Editar' : 'Adicionar'
                                                    )
                                                }
                                                disabled={row.original.pedido ? !podeEditarItem : !podeIncluir}
                                            >
                                                {row.original.pedido ? <ShoppingCart /> : <AddShoppingCart />}
                                            </IconButton>
                                        </span>
                                    </Tooltip>

                                    <Tooltip arrow placement="bottom" title="Cancelar">
                                        <span>
                                            <IconButton
                                                color="error"
                                                onClick={() => onItemAction?.(row.original, row.index, 'Cancelar')}
                                                disabled={!row.original.pedido || !podeCancelarItem}
                                            >
                                                <RemoveShoppingCart />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    {operacao?.sigla === 'XML' && (
                                        <>
                                            <Tooltip arrow placement="top" title="Imprimir informações do item do arquivo XML">
                                                <span>
                                                    <IconButton
                                                        onClick={() =>
                                                            printItemXml({
                                                                cabecalho: dados,
                                                                item: row.original,
                                                                uuid: row.id,
                                                                operacao,
                                                                utiliza3digitos,
                                                            })
                                                        }
                                                    >
                                                        <Print />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>

                                            {!row.original?.produtoId && (
                                                <Tooltip title="Cadastrar ou vincular produto">
                                                    <IconButton
                                                        color="warning"
                                                        onClick={() => handleOpenCadastroRapidoXml(row.original)}
                                                    >
                                                        <Inventory2 />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                        </>
                                    )}
                                    {profile?.id === 'CFR' && (
                                        <>
                                            <Tooltip arrow placement="right" title="Imprimir etiqueta grande">
                                                <span>
                                                    <IconButton
                                                        onClick={() =>
                                                            printEtiquetaGrande({
                                                                cabecalho: dados,
                                                                item: row.original,
                                                                uuid: row.id,
                                                                operacao: operacao,
                                                                utiliza3digitos: utiliza3digitos, //configura formatação das casas decimais
                                                            })
                                                        } //ou calculo a quantidade de itens
                                                        disabled={!row.original.pedido || !podeImprimirItem}
                                                    >
                                                        <Print />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                        </>
                                    )}
                                </Box>
                            </>
                        );
                    }}
                    renderTopToolbarCustomActions={() =>
                        dados?.id && exibeHistoricoCustos ? (
                            <Button
                                type="button"
                                variant="contained"
                                color="warning"
                                size="small"
                                onClick={() => setOpenRecalcularCustos(true)}
                                disabled={isRecalculatingCosts}
                            >
                                {isRecalculatingCosts ? 'Recalculando...' : 'Recalcular custos'}
                            </Button>
                        ) : null
                    }
                />
            </ThemeProvider>
            {openRecalcularCustos && (
                <CustomDialog
                    open
                    title="Recalcular custos dos itens"
                    content={
                        <>
                            Deseja recalcular os custos de todos os itens deste Movimento?
                            <br />
                            <br />
                            Os custos serão calculados novamente com os valores, impostos e descontos atualmente gravados.
                            <br />
                            <br />
                            <strong>Movimento: {dados?.numero ?? dados?.id}</strong>
                        </>
                    }
                    onClose={() => setOpenRecalcularCustos(false)}
                    onConfirm={async () => {
                        const resultado = await onRecalculateCosts?.();

                        if (resultado?.ok) {
                            setOpenRecalcularCustos(false);
                        }
                    }}
                    disableConfirm={isRecalculatingCosts}
                    loading={isRecalculatingCosts}
                    confirmLabel="Recalcular"
                    confirmColor="warning"
                />
            )}
            {openCadastroRapidoXml && (
                <>
                    <CadastroRapidoProdutoXml
                        open={openCadastroRapidoXml}
                        onClose={handleCloseCadastroRapidoXml}
                        itemXml={itemXmlCadastroRapido}
                        empresaId={itemXmlCadastroRapido?.empresaId ?? dados?.empresaId}
                        parametro={parametro}
                        OptionsNCM={[]}
                        OptionsGrupo={[]}
                        OptionsEmbalagem={OptionsEmbalagem}
                        produtosSemelhantes={[]}
                        setFlashMessage={setFlashMessage}
                        onProdutoCriado={(produto) => {
                            atualizarItemXmlResolvido(produto, 'Produto cadastrado com sucesso.');
                        }}
                        onCodigoVinculado={(produto, resultado = {}) => {
                            return atualizarItemXmlResolvido(
                                produto,
                                resultado.somenteVinculoItem ? 'Produto existente selecionado.' : 'Embalagem vinculada com sucesso.',
                                resultado
                            );
                        }}
                    />
                </>
            )}
        </div>
    );
}
